import { Enum } from '@/helpers/choices/enum';

export class EmailContextEnum extends Enum {}

EmailContextEnum.values = {
    SUPPORT: 0,
};

Object.freeze(EmailContextEnum);
